var map = {
	"./bug.svg": 495,
	"./dark.svg": 135,
	"./dragon.svg": 801,
	"./electric.svg": 512,
	"./fairy.svg": 709,
	"./fighting.svg": 407,
	"./fire.svg": 680,
	"./flying.svg": 991,
	"./ghost.svg": 152,
	"./grass.svg": 727,
	"./ground.svg": 259,
	"./ice.svg": 249,
	"./normal.svg": 396,
	"./poison.svg": 4,
	"./psychic.svg": 931,
	"./rock.svg": 395,
	"./steel.svg": 641,
	"./water.svg": 730
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 853;